import { useMsal } from "@azure/msal-react";
import axios from "axios";
import { useEffect, useState } from "react";
import { BASE_API_URL } from "../utils/constants";
import "./Analytics.css";

function Analytics() {
    const [analytics, setAnalytics] = useState(null);

    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();

    const loggedInEnterpriseId =
        activeAccount?.idTokenClaims?.enterpriseID || "";

    const lkmPagesAnalytics = async () => {
        try {
            await axios.post(
                `${BASE_API_URL}/analytics`,
                { enterprise_id: loggedInEnterpriseId },
                {
                    headers: {
                        Authorization: localStorage.getItem("token"),
                        "Content-Type": "application/json",
                    },
                }
            );

            await getAnalytics();
        } catch (error) {
            console.log(error);
        }
    };

    const getAnalytics = async () => {
        try {
            const response = await axios.get(`${BASE_API_URL}/analytics`);
            setAnalytics(response.data?.[0] || null);
        } catch (err) {
            console.log(err);
        }
    };

    const totalUserViews = analytics?.totalUniqueUsers ?? 0;
    const totalViews = analytics?.Data?.totalSum ?? 0;

    useEffect(() => {
        lkmPagesAnalytics();
    }, []);

    return (
        <span className="analytics-span">
            Total Views: {totalViews} &nbsp; | &nbsp;
            Unique Views: {totalUserViews}
        </span>
    );
}

export default Analytics;
